/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { FormBlockStyled } from '../../FormStyled/FormStyled';

export const ReportScheduleStyled = styled.div.attrs({
    className: 'report-schedule',
})`
    max-width: 440px;

    .report-schedule__row {
        display: flex;
        align-items: baseline;
        column-gap: 8px;

        ${FormBlockStyled} {
            max-width: 100px;
            margin-bottom: 8px;
        }
    }

    .report-schedule__prompt {
        ${fonts.textSmall};
        color: ${colors.textColorOpacity};
        margin-bottom: 10px;
    }
`;
